import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "20px" }}>
      <h1>{t("404 - Page not found")}</h1>
      <p>{t("Sorry, the page you are looking for does not exist.")}</p>
      <Link to="/">{t("Back to the home page")}</Link>
    </div>
  );
};

export default NotFoundPage;